import React from 'react';

import { cn } from '@/lib/utils';

interface BudgetCreationStepsProps {
  activeStep: number;
  className?: string;
}

const steps = [
  { number: 1, title: 'Budget' },
  { number: 2, title: 'Members' }
];

const BudgetCreationSteps: React.FC<BudgetCreationStepsProps> = ({ activeStep, className }) => {
  return (
    <div className={cn('hidden md:flex items-center gap-2', className)}>
      {steps.map((step, index) => {
        const isActive = activeStep === step.number;
        const isCompleted = activeStep > step.number;
        const isLast = index === steps.length - 1;

        return (
          <React.Fragment key={step.number}>
            <div className="flex items-center gap-2">
              <span
                className={cn(
                  'size-6 text-sm flex items-center justify-center rounded-full',
                  isActive || isCompleted
                    ? 'bg-primary text-white'
                    : 'bg-transparent border border-lightGray text-secondary'
                )}
              >
                {step.number}
              </span>
              <p className={cn('text-sm', !isActive && !isCompleted && 'text-secondary')}>{step.title}</p>
            </div>
            {!isLast && <div className="h-[1px] w-10 bg-lightGray" />}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default BudgetCreationSteps;
